import { SIDE_NAV_COLLAPSED_WIDTH, SIDE_NAV_WIDTH } from '@/utils/constants';

export default {
  wrapper: {
    backgroundColor: '#FFFFFF',
    width: `${SIDE_NAV_WIDTH}px`,
    padding: '23px 0 0',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    borderRight: '1px solid #E5E9F2',
    collapsed: {
      width: `${SIDE_NAV_COLLAPSED_WIDTH}px`,
    },
  },
  nav: {
    mt: '25px',
    px: '12px',
  },
};
